import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { RiCheckLine } from '@/shared/icons/remix'
import { paletteSuccessMain } from '@/theme/designTokens'
import {
  SP_PASSWORD_RULE_LABELS,
  SP_PASSWORD_RULE_ORDER,
  evaluateSpPasswordRules,
} from '@/features/auth/lib/password-rules'
import {
  webSurveyAccountChecklistItemSx,
  webSurveyAccountChecklistMetItemSx,
  webSurveyAccountChecklistSx,
  webSurveyAccountChecklistTitleSx,
} from '../styles/webSurveyAccountStyles'

interface WebSurveyPasswordChecklistProps {
  readonly password: string
}

export function WebSurveyPasswordChecklist({ password }: WebSurveyPasswordChecklistProps) {
  const checks = evaluateSpPasswordRules(password)

  return (
    <Box data-testid="web-survey-password-checklist" sx={webSurveyAccountChecklistSx}>
      <Typography component="p" sx={webSurveyAccountChecklistTitleSx}>
        Password must contain:
      </Typography>
      <Box
        component="ul"
        sx={{ listStyle: 'none', m: 0, p: 0, display: 'flex', flexDirection: 'column', gap: '4px' }}
      >
        {SP_PASSWORD_RULE_ORDER.map((key) => {
          const met = checks[key]
          return (
            <Box
              component="li"
              key={key}
              data-testid={`web-survey-password-rule-${key}`}
              data-met={met ? 'true' : 'false'}
              sx={met ? webSurveyAccountChecklistMetItemSx : webSurveyAccountChecklistItemSx}
            >
              {met ? (
                <RiCheckLine size={14} color={paletteSuccessMain} aria-hidden />
              ) : (
                <Box component="span" aria-hidden>
                  {'•'}
                </Box>
              )}
              <Typography component="span" sx={{ m: 0, font: 'inherit', color: 'inherit' }}>
                {SP_PASSWORD_RULE_LABELS[key]}
              </Typography>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
